import { Warning } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import { BannerContainer, BannerContent } from "./SwitchPackageBanner.styled";
import type { IBannerState } from "./types";

interface ISwitchPackageBannerProps {
    bannerState: IBannerState;
}

export const SwitchPackageBanner = ({ bannerState }: ISwitchPackageBannerProps) => {
    if (!bannerState.shouldDisplay) {
        return null;
    }

    return (
        <BannerContainer
            $background={bannerState.bannerColor || colorsPalettes.carbon[100]}
            title={
                <BannerContent>
                    <Flex>
                        <Warning
                            size="sm"
                            color={bannerState.iconColor || colorsPalettes.carbon[500]}
                        />
                    </Flex>
                    <Flex>
                        <Text
                            color={bannerState.textColor || colorsPalettes.carbon[500]}
                            fontVariant="body1"
                        >
                            {bannerState.message}
                        </Text>
                    </Flex>
                </BannerContent>
            }
        />
    );
};
